import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import { getListParentKomponenPenilaian } from "@/services/getData"
import SkeletonTable from "@/components/SkeletonTable"

export default function MasterParentKomponenPenilaianPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listParentKomponenPenilaian"],
    queryFn: getListParentKomponenPenilaian,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
